/**
 * @module Message
 */
import GlobalFunctions from '../global'

export default {
  /**
   * Call to message API to send a new message.
   * @function
   * @param {object} message - The message object.
   * @param {string} api - The api to use, either notifications_user or notifications_oma
   * @returns {object} A promise that will return either a success object or an error object.
   */
  sendMessage: function (message, api) {
    return new Promise(function (resolve, reject) {
      GlobalFunctions.$ajax({
        method: 'POST',
        dataType: 'json',
        url: '/notification/sendNotification',
        data: message,
        success: function (response) {
          resolve(response)
        },
        error: function (error) {
          reject(error)
        }
      }, api)
    })
  }
}
